import NavBar from "./NavBar"
import {Animated} from "react-animated-css";

const Header=()=>{
    return (
    <>
      <NavBar Header={true}/>
    </>)
    
}

export default Header


